<div class="card">
    <div class="card-body  admin-model-height formbg-d2">
        <sms-headAdmin></sms-headAdmin>
        <sms-MMMQuery (data)='showQueryData($event)'></sms-MMMQuery>
    </div>
</div>